import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getContact } from "../components/services/soar";

function RCCoTrails(props) {
  const location = useLocation();
  const billingRules = location.state.billingRules;
  const bedDays = location.state.bedDays;
  const payors = location.state.payors;
  const passedData = location.state.data;
  const [contact, setContact] = useState({});
  const [censusPayor, setCensusPayor] = useState(
    payors.filter(
      (payor) => payor.ccx_payor["@name"] === bedDays[0].rule.payor
    )[0]
  );

  useEffect(() => {
    if (!location.state.clientId) {
      return;
    }

    getContact(location.state.clientId).then((response) => {
      console.log("Contact", response[0]);
      setContact(response[0]);
    });
  }, [location.state.clientId]);

  return (
    <>
      <div className="row d-grid justify-content-center mb-4 fw-bold">
        <div>Colorado Department of Human Services</div>
        <div>Trails System Report</div>
        <div>Division of Child Welfare</div>
        <div>OOH Main Provider Roster</div>
        <div>For Service Period</div>
        <div>{`${passedData.startDate} - ${passedData.endDate}`}</div>
      </div>
      <div className="row">
        <div className="col-3 fw-bold">County</div>
        <div className="col-9"></div>
      </div>
      <div className="row">
        <div className="col-3 fw-bold">Governing Body/Provider Name:</div>
        <div className="col-9">
          Specialized Alternatives For Families and Youth
        </div>
      </div>
      <div className="row">
        <div className="col-6"></div>
        <div className="col-3">*Update information on services from</div>
        <div className="col-3">El Paso County</div>
      </div>
      <div className="row">
        <div className="col-6"></div>
        <div className="col-3">and mail to:</div>
        <div className="col-3">County CW Business Staff</div>
      </div>
      <div className="row">
        <div className="col-3 fw-bold">Governing Body:</div>
        <div className="col-3">
          Specialized Alternatives For Families And Youth
        </div>
        <div className="col-3 fw-bold">Provider</div>
        <div className="col-3 text-info">Provider Name</div>
      </div>
      <div className="row">
        <div className="col-3 fw-bold">Address:</div>
        <div className="col-3">
          <div>1600 Specht Point Rd</div>
          <div>Suite 105</div>
          <div>Fort Collins, Colorado 80525</div>
        </div>
        <div className="col-3 fw-bold"></div>
        <div className="col-3 text-info">Provider Address</div>
      </div>
      <div className="row">
        <div className="col-3 fw-bold">Provider ID:</div>
        <div className="col-3"></div>
        <div className="col-3 fw-bold">
          To arrive prior to next payroll period:
        </div>
        <div className="col-3 text-info"></div>
      </div>
      <div className="row">
        <div className="col-3 fw-bold">Service Type:</div>
        <div className="col-3">Foster Family Home Care</div>
        <div className="col-3 fw-bold">Service Category:</div>
        <div className="col-3">OOH</div>
      </div>
      <div className="row mt-4 fw-bold">
        <div className="col-2">Childs Name/ID</div>
        <div className="col-1">State</div>
        <div className="col-1">Sex</div>
        <div className="col-1">Birthday</div>
        <div className="col-1">Worker</div>
        <div className="col-2">Dates of Service</div>
        <div className="col-2">No Days/Units</div>
        <div className="col-2">Amount</div>
      </div>
      <div className="row border-bottom">
        <div className="col-2">{bedDays[0]?.ccx_patient["@name"]}</div>
        <div className="col-1">State</div>
        <div className="col-1">
          {contact && contact.gendercode && contact.gendercode["@name"]}
        </div>
        <div className="col-1">
          {contact && contact.birthdate && contact.birthdate["@date"]}
        </div>
        <div className="col-1">John Doe</div>
        <div className="col-2">{`${passedData.startDate} - ${passedData.endDate}`}</div>
        <div className="col-2">{bedDays.length}</div>
        <div className="col-2">
          {bedDays
            .reduce(
              (total, bd) => total + (bd.rule.rate !== null ? bd.rule.rate : 0),
              0
            )
            .toLocaleString()}
        </div>
      </div>
    </>
  );
}

export default RCCoTrails;
